import React, { useState } from "react";

import { FloorplanOption, Home, IconName } from "../types";
import FloorplanSVG from "./FloorplanSVG";
import Icon from "./Icon";

const FloorplanLightbox = (props: {
  home: Home;
  svg: string;
  selectedOptions: FloorplanOption[];
  onClose: () => void;
}) => {
  const [isClosing, setIsClosing] = useState(false);
  const onClickClose = () => {
    setIsClosing(true);
    setTimeout(function () {
      // Wait for fade out.
      // It is expected that the parent component will remove the Fancybox from the DOM when onClose() is called
      props.onClose();
    }, 600);
  };
  return (
    <div className={`pyht-floorplan-lightbox ${isClosing ? "closing" : ""}`}>
      <div
        className={"close-btn"}
        role={"button"}
        onClick={() => onClickClose()}
      >
        <Icon name={IconName.FANCYBOX_CLOSE} />
      </div>
      <div className={"inner"}>
        <FloorplanSVG
          vpbPkid={props.home.vpb_pkid}
          svg={props.svg}
          layerIds={props.home.floorplan_options.map((option) => option.svg_id)}
          visibleLayers={props.selectedOptions.map((option) => option.svg_id)}
        />
      </div>
    </div>
  );
};

export default FloorplanLightbox;
